jQuery(document).ready(function($) {
    var header = $(".site-header");
    
    $(window).scroll(function() {
        if ($(this).scrollTop() > 50) {
            header.addClass("scrolled");
        } else {
            header.removeClass("scrolled");
        }
    });
});